import { User } from "@/survey";

export function validatePhone(value: string) {
  if(typeof value !== "string" || value.length === 0){
    return true;
  }
  return value.match(/^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/) !== null;
}

export function validatePasswordIf(value: string, siblings: User) {
  if (!siblings.localLoginEnabled) {
    return true;
  }
  const password = value || "";
  if (siblings.id !== null && siblings.id !== undefined && password.length === 0) {
    return true;
  }
  return password.length > 0;
}

export function validatePasswordMinLengthIf(min: number) {
  return function(value: string, siblings: User) {
    const password = value || "";
    if (!siblings.localLoginEnabled || password.length === 0) {
      return true;
    }
    return password.length >= min;
  };
}

export function validatePasswordPatternIf(pattern: RegExp) {
  return function(value: string, siblings: User) {
    const password = value || "";
    if (!siblings.localLoginEnabled || password.length === 0) {
      return true;
    }
    return pattern.test(password);
  };
}
